import { DateService } from "../../../service/DateService";
import { IReportingType } from "../../../model/reporting/ReportingType";

export interface TReportingTypePresentationModel {
  code: string;
  formTypesGroupCategoryCode: string;
  name: string;
  valid: boolean;
  description: string;
  period: number;
  periodMeasureUnit: string;
  repeatingPeriod: boolean;
  periodOfRepetiton?: number;
  periodOfRepetitonMeasureUnit?: string;
  dateFrom: string;
  dateTo?: string;
  tag: string;
  gracePeriodInDays: number;
  npPeriodFrom?: string;
  npPeriodTo?: string;
}

const ReportingTypePresentationModel = (
  data: IReportingType
): TReportingTypePresentationModel => {
  const dateFrom = DateService().formatDate(data.dateFrom);
  const dateTo = data.dateTo
    ? DateService().formatDate(data.dateTo)
    : undefined;
  const npPeriodFrom = data.npPeriodFrom
    ? DateService().formatDate(data.npPeriodFrom)
    : undefined;
  const npPeriodTo = data.npPeriodTo
    ? DateService().formatDate(data.npPeriodTo)
    : undefined;
  return {
    code: data.code,
    formTypesGroupCategoryCode: data.formTypesGroupCategoryCode,
    name: data.name,
    valid: data.valid,
    description: data.description,
    period: data.period,
    periodMeasureUnit: data.periodMeasureUnit,
    repeatingPeriod: data.repeatingPeriod,
    periodOfRepetiton: data.periodOfRepetiton,
    periodOfRepetitonMeasureUnit: data.periodOfRepetitonMeasureUnit,
    dateFrom,
    dateTo,
    tag: data.tag,
    gracePeriodInDays: data.gracePeriodInDays,
    npPeriodFrom,
    npPeriodTo
  };
};

export default ReportingTypePresentationModel;
